/* eslint-disable react-hooks/exhaustive-deps */
import { GrowerDetailCard, TabToggle } from "#components";
import globalConfig from "#constants/globalConfig.js";
import { WebLayout } from "#layouts";
import React, { useEffect, useState } from "react";
import ScoutingManagement from "../scoutingManagement";
import CropPlanManagement from "../cropPlanManagement";
import { useSelector, useDispatch } from "react-redux";
import { setActiveTab } from "../../redux/feature/scoutingActiveTabSlice";

const GrowerDetail = () => {
  const GrowerId = JSON.parse(localStorage.getItem(globalConfig.GROWER_ID));
  const [searchScouting, setSearchScouting] = useState("");
  const [searchCropPlan, setSearchCropPlan] = useState("");
  const [tempSearch, setTempSearch] = useState("");

  const activeTab = useSelector((state) => state.scoutingActiveTab.activeTab);
  const dispatch = useDispatch();

  // Handle tab change
  const handleTabClick = (tabName) => {
    dispatch(setActiveTab(tabName));
  };

  // Determines which component to render based on activeTab
  const returnActiveTabComponent = () => {
    if (activeTab === "Scouting") {
      return (
        <ScoutingManagement
          GrowerId={GrowerId}
          searchInputScouting={tempSearch}
        />
      );
    } else if (activeTab === "Crop Plans") {
      return (
        <div className="tab-pane fade show active">
          <CropPlanManagement searchInputCropPlanList={tempSearch} />
        </div>
      );
    }
    return null;
  };

  // Handle input change
  const handleInputChange = (e) => {
    setTempSearch(e.target.value);
  };

  // Trigger search only on Enter key press
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //   if (activeTab === "Scouting") {
  //     setSearchScouting(tempSearch);
  //   } else {
  //     setSearchCropPlan(tempSearch);
  //   }
  //   }
  // };

  useEffect(() => {
    if (tempSearch === "") {
      if (activeTab === "Scouting") {
        setSearchScouting(tempSearch);
      } else {
        setSearchCropPlan(tempSearch);
      }
    }
  }, [tempSearch]);
  useEffect(() => {
    setTempSearch(""); // Reset tempSearch when activeTab changes
    setSearchScouting("");
    setSearchCropPlan("");
  }, [activeTab]);

  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <GrowerDetailCard GrowerId={GrowerId} />
          <div className="row mt-4">
            <div className="col-xl-12">
              <div className="flex-between">
                <TabToggle
                  data={["Scouting", "Crop Plans"]}
                  activeTab={activeTab}
                  handleTabClick={handleTabClick}
                />
                {/* <div className="form-block p-relative">
                  <input
                    type="text"
                    className="form-control"
                    id="search"
                    placeholder="Search"
                    value={tempSearch}
                    onChange={handleInputChange}
                    // onKeyDown={handleKeyDown} // Ensures search happens only on Enter
                  />
                  <span className="search-icon" />
                </div> */}
              </div>
              <div className="tab-content pt-4">
                {returnActiveTabComponent()}
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default GrowerDetail;
